<template>
  <article class="infographic-card">
    <div class="infographic-card__media">
      <img
        v-if="item.previewImage && !previewFailed"
        class="infographic-card__preview"
        v-bind:src="item.previewImage"
        v-bind:alt="item.title"
        loading="lazy"
        v-on:error="previewFailed = true"
      />
      <div v-else class="infographic-card__fallback" aria-hidden="true"></div>
      <span class="infographic-card__pill">Infographic</span>
    </div>

    <div class="infographic-card__body">
      <p class="infographic-card__topic" v-if="item.topic">{{ item.topic }}</p>
      <h2 class="infographic-card__title">{{ item.title }}</h2>
      <p class="infographic-card__description" v-if="item.description">
        {{ item.description }}
      </p>

      <div class="infographic-card__actions">
        <a
          v-if="item.downloadUrl"
          class="infographic-card__download"
          v-bind:href="item.downloadUrl"
          v-bind:download="item.downloadFilename || true"
        >
          Get the infographic
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M12 5v12" />
            <path d="m6 13 6 6 6-6" />
            <path d="M5 21h14" />
          </svg>
        </a>

        <router-link
          v-if="hasInternalBlog"
          class="infographic-card__read"
          v-bind:to="item.blogHref"
        >
          Read the blog
        </router-link>
        <a
          v-else-if="item.blogHref"
          class="infographic-card__read"
          v-bind:href="item.blogHref"
        >
          Read the blog
        </a>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "InfographicCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      previewFailed: false,
    };
  },
  computed: {
    hasInternalBlog() {
      const href = this.item.blogHref;
      return typeof href === "string" && href.startsWith("/") && !href.startsWith("//");
    },
  },
};
</script>
